import Ledger from "./Ledger";

const LedgerPage = () => (
	<div className="lavella page ledger-page">
		<section>
			<div className="cont--lg">
				<Ledger />
			</div>
		</section>
	</div>
);

export default LedgerPage;
